const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/position-search/api-factory');
const serviceFactory = require('../resources/position-search/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/position-search/${apiConfig.apiversion}/`
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app
    .match(`${p}positionsearch.getRecentSearch[{keys:noOfRows}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getRecentSearch(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
      .match(`${p}positionsearch.getPortfolioOrPositionData[{keys:searchText}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getPortfolioOrPositionData(req.params)
            .then(response => res.value(response))
            .catch(res.error)
        )))
        .match(`${p}positionsearch.onSaveOrUpdateSearchText[{keys:requestBody}][{keys:guidStr}]`, requests => Promise.all(
            requests.map(({ req, res }) =>
              service.saveSearch(req.params)
                .then(response => res.value(response))
                .catch(res.error)
        )))  
  }

module.exports = addRoutes;
